webpackJsonp([15666838199965],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"], ["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Tos = function Tos() {
	  return _react2.default.createElement(
	    Contents,
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Allgemeine Gesch\xE4ftsbedingungen"
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "1. Einleitung"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Willkommen bei Jurek Barth (\"Firma\", \"wir\", \"uns\", \"unseres\", \"Anbieter\"). Du hast gerade auf unsere allgemeinen Gesch\xE4ftsbedingungen geklickt. Bitte lese diese Allgemeinen Gesch\xE4ftsbedingungen daher aufmerksam durch."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "2. Inhalte"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Mit unserem Service kannst du bestimmte Informationen, Texte, Grafiken, Videos oder anderes Material (\"Inhalt\") ver\xF6ffentlichen, verkn\xFCpfen, speichern, teilen und anderweitig verf\xFCgbar machen. Du bist f\xFCr diese Inhalte verantwortlich, einschlie\xDFlich deren Rechtm\xE4\xDFigkeit, Zuverl\xE4ssigkeit und Angemessenheit."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "3. Teilnahmevoraussetzungen"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Die Nutzung unserer Services erfolgt auf eigenes Risiko."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "4. Registrierung"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "4.1. Die Nutzung unserer Services setzt die Einrichtung eines Nutzerkontos voraus. Hierf\xFCr ist es erforderlich, dass der Nutzer pers\xF6nliche Daten wie beispielsweise Email eingibt. Die Er\xF6ffnung eines Nutzerkontos ist \xFCber unsere mobilen Apps m\xF6glich. Die Registrierung kann alternativ auch mittels eines Drittanbieters (Apple) erfolgen. Einzelne f\xFCr die Registrierung erforderliche Daten des Nutzers werden dann aus dem Konto des Drittanbieters \xFCbertragen. Der Nutzer wird bei der Registrierung von dem Anbieter aufgefordert, die Allgemeinen Gesch\xE4ftsbedingungen und die Datenschutzbestimmungen zu akzeptieren. Nach erfolgter Anmeldung, \xFCbersendet der Anbieter dem Nutzer eine E-Mail, in der er ihn darum bittet, die Anmeldung durch Klicken auf den Button \"E-Mail best\xE4tigen\" zu verifizieren oder den Code in der Email daf\xFCr zu verwenden. Nach best\xE4tigen der Email, wird der Nutzer in die App oder auf die Webseite weitergeleitet, wo der Anbieter die Anmeldung final best\xE4tigt. Erst danach ist der Anmeldeprozess abgeschlossen."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "4.2. Mit Akzeptanz dieser AGB, erlaubt der Nutzer dem Anbieter, ihm Informations- und Werbe-E-Mails passend zum Produkt an die angegebene E-Mail Adresse zu senden. Der Nutzer hat mit jedem Erhalt der Informations- und Werbe-E-Mails die M\xF6glichkeit, sich von Informations- und Werbe-E-Mails abzumelden oder dem Erhalt zu widersprechen. Ab dem Zeitpunkt der Abmeldung beziehungsweise nach Bearbeitung des Widerspruchs erh\xE4lt der Nutzer keine Informations- und Werbe-E-Mails mehr."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "5. Verf\xFCgbarkeit und Haftung"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "5.1. Der Anbieter bietet seine Leistungen nach Art und Umfang auf der Grundlage der aktuellen technischen, rechtlichen und kommerziellen Rahmenbedingungen des Internets an. Der Anbieter ist bemu\u0308ht, den Online Zugang zu den Produkten 24 Stunden t\xE4glich und an 7 Tagen pro Woche zur Verfu\u0308gung zu stellen. Allerdings wird keine Haftung fu\u0308r die st\xE4ndige Verfu\u0308gbarkeit u\u0308bernommen."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "5.2 Auch im \xDCbrigen sind Anspru\u0308che des Nutzers auf Schadensersatz ausgeschlossen. Hiervon ausgenommen sind Schadensersatzanspru\u0308che des Nutzers aus der Verletzung des Lebens, des K\xF6rpers, der Gesundheit oder aus der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) sowie die Haftung f\xFCr sonstige Sch\xE4den, die auf einer vors\xE4tzlichen oder grob fahrl\xE4ssigen Pflichtverletzung des Anbieters, seiner gesetzlichen Vertreter oder Erf\xFCllungsgehilfen beruhen. Wesentliche Vertragspflichten sind solche, deren Erf\xFCllung zur Erreichung des Ziels des Vertrags notwendig ist."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "5.3. Bei der Verletzung wesentlicher Vertragspflichten haftet der Anbieter nur auf den vertragstypischen, vorhersehbaren Schaden, wenn dieser einfach fahrl\xE4ssig verursacht wurde, es sei denn, es handelt sich um Schadensersatzanspru\u0308che des Nutzers aus einer Verletzung des Lebens, des K\xF6rpers oder der Gesundheit."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "5.4. Die Einschr\xE4nkungen der Ziffern 5.2. und 5.3. gelten auch zugunsten der gesetzlichen Vertreter und Erfu\u0308llungsgehilfen des Anbieters, wenn Anspru\u0308che direkt gegen diese geltend gemacht werden."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "5.5. Die Vorschriften des Produkthaftungsgesetzes bleiben unberu\u0308hrt."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "6. \xC4nderungen der AGB"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "6.1. Der Anbieter ist jederzeit berechtigt diese AGB zu \xE4ndern."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "6.2. Im Falle einer \xC4nderung der AGB wird der Anbieter den Nutzer hier\xFCber in Textform in Kenntnis setzen. Die Zustimmung des Nutzers zu den entsprechenden Vertrags\xE4nderungen gilt dabei als erteilt, sofern der Nutzer der \xC4nderung der AGB nicht binnen zwei (2) Wochen nach Zugang der \xC4nderungsmitteilung in Textform widerspricht. Der Anbieter wird den Nutzer zusammen mit der \xC4nderungsmitteilung nochmals ausdr\xFCcklich auf diese Folge eines unterlassenen Widerspruchs hinweisen."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "6.3. F\xFCr den Fall, dass der Nutzer seine Zustimmung zu den \xC4nderungen der AGB mit Wirkung auf ein bestehendes Vertragsverh\xE4ltnis verweigert, ist der Anbieter berechtigt, den Vertrag \u2013 unter Fortsetzung zu den bisherigen Bedingungen \u2013 zum Ablauf der unter Ber\xFCcksichtigung des n\xE4chstm\xF6glichen K\xFCndigungszeitpunktes aktuellen Vertragslaufzeit zu k\xFCndigen. Eine erneute Teilnahme an den Leistungen wird dem Nutzer anschlie\xDFend nur noch zu den jeweils aktuellen AGB angeboten."
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "7. Schlussbestimmungen"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "7.1. Sollten einzelne Bestimmungen dieser Allgemeinen Gesch\xE4ftsbedingungen ganz oder in Teilen unwirksam sein oder werden, bleibt die G\xFCltigkeit der \xFCbrigen Bestimmungen davon unber\xFChrt."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "7.2. Es findet das Recht der Bundesrepublik Deutschland unter Ausschluss der Vorschriften des UN-Kaufrechts (CISC) Anwendung. Im Gesch\xE4ftsverkehr mit Verbrauchern innerhalb der Europ\xE4ischen Union kann auch das Recht am Wohnsitz des Verbrauchers anwendbar sein, sofern es sich um zwingend anzuwendende verbraucherrechtliche Bestimmungen handelt."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "7.3. Sollte der Nutzer keinen allgemeinen Gerichtsstand in Deutschland oder in einem anderen EU-Mitgliedsstaat haben, Kaufmann sein oder seinen festen Wohnsitz nach Wirksamwerden dieser AGB ins Ausland verlegen oder sein Wohnsitz oder gew\xF6hnlicher Aufenthaltsort im Zeitpunkt der Klageerhebung nicht bekannt sein, ist ausschlie\xDFlicher Gerichtsstand der Gesch\xE4ftssitz des Anbieters."
	      )
	    )
	  );
	};
	
	var Contents = _styledComponents2.default.div(_templateObject);
	
	exports.default = Tos;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tos-js-ef129cf5e986d44ffb15.js